import { Box, Button, Typography, useMediaQuery, useTheme } from "@mui/material"
import { hasRole } from "auth/hasRole"
import { AppContext } from "components/AppContextProvider"
import ClpTable from "components/ClpTable"
import { MultiSelectFilter } from "components/ClpTable/ClpTableFilterTypes"
import TableButton from "components/ClpTable/components/actions/TableButton/TableButton"
import { TableButtonTypeEnum } from "components/ClpTable/components/actions/TableButton/tableButtonProps.interface"
import { allRoles } from "generated/roles"
import { allRoutes } from "generated/routes"
import { issueReportStatusLabel } from "helpers/IssueReports/IssueReportStatusLabel"
import { issueReportStatusData, prio } from "pages/issuereports/pages/archive/components/table/helpers"
import { useCallback, useContext, useEffect, useState } from "react"
import { Link, useHistory } from "react-router-dom"
import TableDropdown, {
  StatusDropdown
} from "components/ClpTable/components/actions/TableDropdown/TableDropdown"
import { ActionType } from "./components/InspectionBookingSidebar.interfaces"
import { apiEndpoints } from "generated/apiEndpoints"
import { useApi } from "auth/useApi3"
import { initialModalState, ModalDialog } from "./components/ModalDialog"
import { useTranslation } from "react-i18next"
import ChipPriority from "components/Status/ChipInfo/ChipPriority"
import ChipInfoIcon from "components/Status/ChipInfo/ChipInfoIcon"
import { issueReportChip } from "pages/issuereports/issurereport.interface"
import PaperBox from "components/PaperBox"

const IssueReportsCard = ({ 
  vehicleId, 
  data, 
  fetchIssueReports, 
  tabValue, 
  tabHistory, 
  setTabHistory, 
  tabValueIndex }) => {
  const { t } = useTranslation()
  const appContext = useContext(AppContext)
  const userHasIssueReportAdmin = hasRole(appContext.appUser, allRoles.IssueReportsAdmin)
  const history = useHistory()
  const theme = useTheme()
  const [newIssueReportValues, setNewIssueReportValues] = useState({})
  const [singleIssueReportResult, singleIssueReportApi] = useApi()
  const [issueReportPutResult, issueReportPutApi] = useApi()
  const [modalData, setModalData] = useState(initialModalState)
  const priorityOptions = [0, 1, 2, 3, 4].map((priority) => ({ value: priority, name: prio(priority, t) }))
  const statusOptions = [1, 2, 3, 4, 5].map((status) => ({
    value: status,
    name: issueReportStatusData(status, theme, t).label
  }))

  useEffect(() => {

    console.log("tabHistory", tabHistory)
      if (tabHistory.find(x => x === tabValueIndex.IssueReports)) {
      } else {
        if (tabValue === tabValueIndex.IssueReports) {
            fetchIssueReports()
        }
        setTabHistory([...tabHistory, tabValueIndex.IssueReports])
      }
      console.log("tabValue",tabValueIndex.IssueReports)
      console.log("TAB HISTORY",tabHistory)
    }, [tabValueIndex])

  useEffect(() => {
    if (issueReportPutResult.status !== 2) return
    fetchIssueReports()
  }, [issueReportPutResult])

  const fetchSingleIssueReport = (id) => {
    singleIssueReportApi.get(apiEndpoints.issuereports.getissuereport.replace("{id}", id))
  }

  const columns = [
    {
      accessorKey: "issueReportId",
      header: t("global.id", "ID"),
      cell: ({ row }) => {
        return (
          <Typography
            display="block"
            style={{
              color: "inherit",
              textDecoration: "inherit"
            }}
            component={Link}
            to={allRoutes.IssuereportsArchiveIssuereport(row.original.issueReportId)}>
            {row.original.issueReportId}
          </Typography>
        )
      }
    },
    {
      accessorKey: "description",
      header: t("global.description", "Beskrivning"),
      cell: ({ row }) => {
        return (
          <Typography
            display="block"
            style={{
              color: "inherit",
              textDecoration: "inherit"
            }}
            component={Link}
            to={allRoutes.IssuereportsArchiveIssuereport(row.original.issueReportId)}>
            {row.original.description}
          </Typography>
        )
      }
    },
    {
      accessorKey: "workOrderId",
      header: t("global.workorder", "Workorder"),
      cell: ({ row }) => {
        return (
          <Typography
            display="block"
            style={{
              color: "inherit",
              textDecoration: "inherit"
            }}
            component={Link}
            to={allRoutes.IssuereportsArchiveIssuereport(row.original.issueReportId)}>
            {row.original.workOrderId > 0 ? `#${row.original.workOrderId}` : `-`}
          </Typography>
        )
      }
    },
    {
      accessorKey: "categoryName",
      header: t("global.category", "Kategori")
    },
    {
      accessorFn: (row) => prio(row.priority, t),
      header: t("global.table.priority", "Priority"),
      filterFn: "arrIncludesSome",
      meta: {
        mainFilter: true,
        filter: MultiSelectFilter,
        filterHeader: t("global.table.priority", "Priority"),
        align: useMediaQuery(theme.breakpoints.up("xl")) ? "left" : "right"
      },
      cell: ({ cell }) => {
        return userHasIssueReportAdmin ? (
          <TableDropdown
            initialValue={cell.row.original.priority}
            handleOnChange={(event) => {
              setModalData({
                actionType: ActionType.Confirm,
                isOpen: true,
                title: t("global.change_priority", "Change priority"),
                message: `${t(
                  "global.change_the_priority_of",
                  "Are you sure you want to change the priority of"
                )} ${cell.row.original.categoryName} ${t("global.from", "from")} ${prio(
                  cell.row.original.priority,
                  t
                )} ${t("global.to", "to")} ${prio(event.target.value, t)}?`
              })
              setNewIssueReportValues({ priority: event.target.value })
              fetchSingleIssueReport(cell.row.original.issueReportId)
            }}
            options={priorityOptions}
          />
        ) : (
          <ChipPriority type={cell.row.original.priority} />
        )
      }
    },
    {
      accessorFn: (row) => issueReportStatusLabel(row.status, t),
      cell: ({ cell }) => {
        const currentStatusData = issueReportStatusData(cell.row?.original?.status, theme, t)
        return userHasIssueReportAdmin ? (
          <StatusDropdown
            onChange={(event) => {
              const newStatusData = issueReportStatusData(event.target.value, theme, t)
              setModalData({
                actionType: ActionType.Confirm,
                isOpen: true,
                title: t("global.change_status", "Change status"),
                message: `${t(
                  "global.change_the_status_of",
                  "Are you sure you want to change the status of"
                )} ${cell.row.original.categoryName} ${t("global.from", "from")} ${
                  currentStatusData.modalLabel
                } ${t("global.to", "to")} ${newStatusData.modalLabel}?`
              })
              setNewIssueReportValues({ status: event.target.value })
              fetchSingleIssueReport(cell.row.original.issueReportId)
            }}
            value={cell.row?.original?.status || 1}
            options={statusOptions}
            label={currentStatusData.label}
            icon={currentStatusData.icon}
            color={currentStatusData.color}
            backgroundColor={currentStatusData.backgroundColor}
            iconColor={currentStatusData.iconColor}
          />
        ) : (
          <ChipInfoIcon type={issueReportChip(cell.row?.original?.status)} />
        )
      },
      header: t("global.status", "Status"),
      filterFn: "arrIncludesSome",
      meta: {
        filter: MultiSelectFilter,
        filterHeader: t("global.status", "Status"),
        align: useMediaQuery(theme.breakpoints.up("xl")) ? "left" : "right",
        mainFilter: true
      }
    },
    {
      cell: ({ cell }) => {
        return (
          hasRole(appContext.appUser, allRoles.IssueReportsAdmin) && (
            <TableButton
              type={TableButtonTypeEnum.Edit}
              handleOnClick={() => {
                history.push(allRoutes.IssuereportsArchiveIssuereport(cell.row.original.issueReportId))
              }}
            />
          )
        )
      },
      accessorKey: "action",
      header: "",
      meta: {
        align: "right",
        hiddenFilter: true
      }
    }
  ]

  return (
    <>
      <ModalDialog
        modalData={modalData}
        setModalData={setModalData}
        setShowSidebar={() => {}}
        handleSubmit={() => {
          const putValues = {
            ...singleIssueReportResult?.data,
            ...newIssueReportValues
          }
          issueReportPutApi.put(apiEndpoints.issuereportsadmin.updateissuereport, putValues)
        }}
        handleCancel={() => setNewIssueReportValues({})}
        disabled={singleIssueReportResult.status !== 2}
      />
      <PaperBox mt={0} sx={{ padding: "0px !important" }}>
        {hasRole(appContext.appUser, allRoles.IssueReportsAdmin) && (
          <Box display="flex" justifyContent="flex-end" pt={{ xs: 2, md: 3 }} px={{ xs: 2, md: 3 }}>
            <Button
              variant="contained"
              component={Link}
              to={{
                pathname: allRoutes.IssuereportsWorkordersAdd(),
                state: vehicleId
              }}>
              {t("global.create_work_order", "Create work order")}
            </Button>
          </Box>
        )}
        <ClpTable
          rows={data.status === 2 && data.data}
          loadingState={data.status}
          hideFilter={false}
          columns={columns}
        />
      </PaperBox>
    </>
  )
}

export default IssueReportsCard
